const MARKET_DOMAINS: Record<string, { host: string; prefix: string }> = {
  sv: { host: 'www.careofcarl.se', prefix: 'sv' },
  en: { host: 'www.careofcarl.com', prefix: 'en' },
  de: { host: 'www.careofcarl.de', prefix: 'de' },
  no: { host: 'www.careofcarl.no', prefix: 'no' },
  da: { host: 'www.careofcarl.dk', prefix: 'da' },
  fi: { host: 'www.careofcarl.fi', prefix: 'fi' },
  fr: { host: 'www.careofcarl.com', prefix: 'fr' },
  es: { host: 'www.careofcarl.com', prefix: 'es' },
  it: { host: 'www.careofcarl.com', prefix: 'it' },
  nl: { host: 'www.careofcarl.com', prefix: 'nl' },
};
const KNOWN_URL_PREFIXES = new Set(Object.values(MARKET_DOMAINS).map((m) => m.prefix));

export function localizeProductUrl(url: unknown, lang?: string): string {
  const raw = String(url ?? '').trim();
  if (!raw || !lang || lang === 'sv') return raw;
  const market = MARKET_DOMAINS[lang];
  if (!market) return raw;
  try {
    const u = new URL(raw);
    if (!/(^|\.)careofcarl\./i.test(u.hostname)) return raw;
    const segs = u.pathname.split('/').filter(Boolean);
    if (segs.length === 0 || !KNOWN_URL_PREFIXES.has(segs[0].toLowerCase())) return raw;
    u.hostname = market.host;
    segs[0] = market.prefix;
    u.pathname = '/' + segs.join('/');
    return u.toString();
  } catch {
    return raw;
  }
}
